import React, { useState, useEffect, useCallback } from 'react';
import api from '../api';
import { useAuth } from '../context/AuthContext';

export default function ApprovalCenter() {
  const { isAdmin } = useAuth();
  const [data, setData] = useState(null);

  const load = useCallback(() => { api.get('/approvals').then(r => setData(r.data)).catch(()=>{}); }, []);
  useEffect(() => { load(); }, [load]);
  if (!isAdmin) return <div style={{ padding:40, color:'var(--text2)', textAlign:'center' }}>Admin access required</div>;
  if (!data) return <div style={{ color:'var(--text2)' }}>Loading…</div>;

  const act = async (url, body) => { await api.post(url, body); load(); };
  const rejectDelay = (id) => { const r = window.prompt('Reason for rejecting this delay (mandatory):'); if (r && r.trim()) act(`/approvals/delay/${id}`, { decision:'reject', remarks:r.trim() }); };
  const clarifyDelay = (id) => { const r = window.prompt('What clarification do you need?'); if (r && r.trim()) act(`/approvals/delay/${id}`, { decision:'clarify', remarks:r.trim() }); };

  const total = data.counts.registrations + data.counts.class_teachers + data.counts.delays;

  const Section = ({ title, count, children }) => (
    <div style={{ marginBottom:22 }}>
      <div style={{ fontSize:13, fontWeight:600, marginBottom:10 }}>{title} {count > 0 && <span className="badge badge-pending" style={{ marginLeft:4 }}>{count}</span>}</div>
      {count === 0 ? <div className="card"><div style={{ fontSize:13, color:'var(--text2)', padding:'4px 0' }}>Nothing pending.</div></div> : children}
    </div>
  );

  return (
    <div>
      <div style={{ marginBottom:18 }}>
        <h2 style={{ fontSize:18, fontWeight:600, marginBottom:4 }}>Approval Center {total>0 && <span className="badge badge-pending">{total}</span>}</h2>
        <p style={{ fontSize:13, color:'var(--text2)' }}>All pending approvals in one place.</p>
      </div>

      <Section title="👤 User Registrations" count={data.counts.registrations}>
        <div className="card" style={{ padding:0, overflow:'hidden' }}><div className="table-wrap"><table>
          <thead><tr><th>Name</th><th>Email</th><th>Campus</th><th>Requested</th><th>Action</th></tr></thead>
          <tbody>{data.registrations.map(r => (
            <tr key={r.id}>
              <td style={{ fontSize:13, fontWeight:500 }}>{r.full_name}</td>
              <td style={{ fontSize:13 }}>{r.email}</td>
              <td style={{ fontSize:13 }}>{(r.campuses||[]).join(', ') || '—'}</td>
              <td style={{ fontSize:12, color:'var(--text2)' }}>{new Date(r.created_at).toLocaleDateString()}</td>
              <td><div className="flex-gap" style={{ gap:6 }}>
                <button className="btn btn-primary btn-sm" onClick={() => act(`/approvals/registration/${r.id}`, { decision:'approve' })}>Approve</button>
                <button className="btn btn-danger btn-sm" onClick={() => { if(window.confirm('Reject and remove this registration?')) act(`/approvals/registration/${r.id}`, { decision:'reject' }); }}>Reject</button>
              </div></td>
            </tr>
          ))}</tbody>
        </table></div></div>
      </Section>

      <Section title="🎓 Class Teacher Assignments" count={data.counts.class_teachers}>
        <div className="card" style={{ padding:0, overflow:'hidden' }}><div className="table-wrap"><table>
          <thead><tr><th>Staff</th><th>Campus</th><th>Room</th><th>Action</th></tr></thead>
          <tbody>{data.class_teachers.map(r => (
            <tr key={r.id}>
              <td style={{ fontSize:13, fontWeight:500 }}>{r.staff_name}</td>
              <td style={{ fontSize:13 }}>{r.campus_name}</td>
              <td style={{ fontSize:13 }}>{r.room_name || '—'}</td>
              <td><div className="flex-gap" style={{ gap:6 }}>
                <button className="btn btn-primary btn-sm" onClick={() => act(`/approvals/class-teacher/${r.id}`, { decision:'approve' })}>Approve</button>
                <button className="btn btn-danger btn-sm" onClick={() => act(`/approvals/class-teacher/${r.id}`, { decision:'reject' })}>Reject</button>
              </div></td>
            </tr>
          ))}</tbody>
        </table></div></div>
      </Section>

      <Section title="⏰ Task Delay Requests" count={data.counts.delays}>
        <div className="card" style={{ padding:0, overflow:'hidden' }}><div className="table-wrap"><table>
          <thead><tr><th>Task</th><th>Campus</th><th>IT Staff</th><th>Delay Reason</th><th>Action</th></tr></thead>
          <tbody>{data.delays.map(r => (
            <tr key={r.id}>
              <td style={{ fontSize:13, fontWeight:500 }}>{r.task_name}</td>
              <td style={{ fontSize:13 }}>{r.campus_name}</td>
              <td style={{ fontSize:13 }}>{r.staff_name || '—'}</td>
              <td style={{ fontSize:13 }}>{r.delay_reason}</td>
              <td><div className="flex-gap" style={{ gap:6, flexWrap:'wrap' }}>
                <button className="btn btn-primary btn-sm" onClick={() => act(`/approvals/delay/${r.id}`, { decision:'approve' })}>Approve</button>
                <button className="btn btn-danger btn-sm" onClick={() => rejectDelay(r.id)}>Reject</button>
                <button className="btn btn-secondary btn-sm" onClick={() => clarifyDelay(r.id)}>Request Clarification</button>
              </div></td>
            </tr>
          ))}</tbody>
        </table></div></div>
      </Section>

      <div style={{ fontSize:11, color:'var(--text3)' }}>Future approval types (asset requests, role changes, access requests) will appear here as they are added.</div>
    </div>
  );
}
